import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import thunk from "redux-thunk";

import { navbarReducer } from "./slices/navbarSlice";
// import { loadingReducer } from "./slices/loadingSlice";
// import { linkListReducer } from "./slices/linkListSlice";
// import { customerListReducer } from "./slices/customerListSlice";
// import { vpListReducer } from "./slices/vpListSlice";
// import { parametersReducer } from "./slices/parametersSlice";
// import { sheetPaymentFiltersReducer } from "./slices/sheetPaymentFiltersSlice";
// import { freePaymentReducer } from "./slices/freePaymentSlice";
// import { appInitialReducer } from "./slices/appInitialSlice";
// import { orderReportReducer, } from "./slices/orderReportSlice";
// import { linkParametersReducer } from "./slices/linkParametersSlice";
// import { IntegrationReducer } from "./slices/IntegrationSlice";
// import { lastOrderListReducer } from "./slices/lastOrderListSlice";
// import { orderSummaryTotalReducer } from "./slices/orderSummaryTotalSlice";
// import { orderSummariesReducer } from "./slices/orderSummariesSlice";
// import { orderChartSummaryListReducer } from "./slices/orderChartSummaryListSlice";
// import { packageReducer } from "./slices/packageSlice";
// import { emailSmsPackageReducer } from "./slices/emailSmsPackageSlice";
// import { bankListReducer } from "./slices/bankListSlice";
// import { erpParameterReducer } from "./slices/erpParameterSlice";
// import { erpValuesReducer } from "./slices/erpValuesSlice";
// import { formHelperReducer } from "./slices/formHelperSlice";
// import { contractsReducer } from "./slices/contractsSlice";
// import {  erpIntegrationReducer } from "./slices/erpIntegrationCustomerSlice";
// import {  vpDetailReducer } from "./slices/vpDetailSlice";
const rootPersistConfig = {
  key: "root",
  storage,
  stateReconciler: autoMergeLevel2,
};

const rootReducer = combineReducers({
  // loading: loadingReducer,
  navbar: navbarReducer,
  // linklist: linkListReducer,
  // customerlist: customerListReducer,
  // vpList: vpListReducer,
  // parameters: parametersReducer,
  // sheetPaymentFilters : sheetPaymentFiltersReducer,
  // freePayment : freePaymentReducer,
  // orderReport: orderReportReducer,
  // appInitial : appInitialReducer,
  // linkParameters : linkParametersReducer,
  // Integration : IntegrationReducer,
  // lastOrderList:lastOrderListReducer,
  // orderSummaryTotal:orderSummaryTotalReducer,
  // orderSummaries:orderSummariesReducer,
  // orderChartSummaryList:orderChartSummaryListReducer,
  // package:packageReducer,
  // emailSmsPackage:emailSmsPackageReducer,
  // bankList:bankListReducer,
  // erpParameters:erpParameterReducer,
  // erpValues : erpValuesReducer,
  // formHelper : formHelperReducer,
  // contracts : contractsReducer,
  // erpIntegrationCustomer:erpIntegrationReducer,
  // vpDetail : vpDetailReducer

});
const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export const persistor = persistStore(store);
